<template>
  <CustomModal id="new-series-modal"
               class="basic-modal new-series-modal"
               v-bind:ok-disabled="newSeriesDisabled"
               v-bind:ok-busy="busy"
               v-on:cancel="$emit('cancel')"
               v-on:ok="create()">
    <div class="new-series-modal__title" slot="modal-header">
      {{ $t('publishers.modal.new_series.title') }}
    </div>

    <div class="new-series-modal__form">
      <div class="form-group">
        <label for="subject-select"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.new_series.subject') }}
        </label>
        <select v-model="selected.subjectId" id="subject-select" class="form-control">
          <option disabled value="">
            {{ $t('publishers.modal.new_series.subject_placeholder') }}
          </option>
          <option v-for="sjId in subjectIds.filter(id => id !== '0' && id !== '9999')"
                  v-bind:key="sjId"
                  v-bind:value="sjId">
            {{ getTranslatedName(subjectMap[sjId]) }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="grade-select"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.new_series.grade') }}
        </label>
        <select v-model="selected.gradeId" id="grade-select" class="form-control">
          <option disabled value="">
            {{ $t('publishers.modal.new_series.grade_placeholder') }}
          </option>
          <option v-for="gId in gradeIds.filter(id => id !== '0' && id !== '9999')"
                  v-bind:key="gId"
                  v-bind:value="gId">
            {{ getTranslatedName(gradeMap[gId]) }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="series-title-input"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.new_series.name') }}
        </label>
        <input 
          type="text"
          id="series-title-input"
          class="form-control"
          v-bind:placeholder="$t('publishers.modal.new_series.name_placeholder')"
          v-model="seriesTitle"
        >
      </div>

      <div class="form-group" v-show="showChapterSelect">
        <label for="chapter-count-select"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          {{ $t('publishers.modal.new_series.unit') }}
        </label>
        <select v-model="selected.chapterCount" id="chapter-count-select" class="form-control">
          <option disabled value="">
            {{ $t('publishers.modal.new_series.unit_placeholder') }}
          </option>
          <option v-for="n in 20" v-bind:key="n" v-bind:value="n">
            {{ n }}
          </option>
        </select>
      </div>

    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, isString, isNil } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'new-series-modal',

    props: {
      publisherId: {
        type: Number,
        default: null,
      },
    },

    mixins: [
      labels,
    ],

    data() {
      return {
        selected: {
          subjectId: '',
          gradeId: '',
          chapterCount: '',
        },
        seriesTitle: '',
        showChapterSelect: false,
        busy: false,
      };
    },

    watch: {
      selectedSubjectGrade(value) {
        if (!isNil(value.match(/[0-9]+&[0-9]+/))) {
          return this.fetchUnits({
            subject_id: this.selected.subjectId,
            grade_id: this.selected.gradeId,
          })
          .then((units) => {
            this.selected.chapterCount = units.length || '';
            this.showChapterSelect = units.length === 0;
          });
        }

        if (value.match(/[0-9]+&null/)) {
          this.showChapterSelect = true;
        }

        return null;
      },
    },

    computed: {
      ...mapGetters([
        'subjectMap',
        'subjectIds',
        'gradeMap',
        'gradeIds',
      ]),

      selectedSubjectGrade() {
        return `${this.selected.subjectId}&${this.selected.gradeId}`;
      },

      newSeriesDisabled() {
        if (isEmpty(this.selected.subjectId) || isEmpty(this.selected.gradeId)) {
          return true;
        }

        if (isEmpty(this.seriesTitle)) {
          return true;
        }

        if (isString(this.selected.chapterCount)) {
          return true;
        }

        return false;
      },
    },

    methods: {
      ...mapActions([
        'createNewSeries',
        'fetchUnits',
      ]),

      create() {
        if (!this.busy) {
          this.busy = true;
  
          const params = {
            name: this.seriesTitle,
            publisher_id: this.publisherId,
            subject_id: this.selected.subjectId,
            grade_id: this.selected.gradeId === 'null' ? null : this.selected.gradeId,
            chapters_count: this.selected.chapterCount,
          };
  
          this.createNewSeries(params)
            .then(() => (
              this.$emit('ok')
            ));
        }
      },
    },
  };
</script>

<style lang="scss">
  .new-series-modal {
    .modal-dialog {
      @media (min-width: 480px) {
        width: 460px !important;
      }
    }

    .new-series-modal__form {
      .form-group>.form-control {
        height: 47px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/NewSeriesModal.vue